export function addDefaultAction(richtextarea) {
  return {
      type: 'ADD_CURRENT',
      richtextarea,
  }
}